import type { z } from "zod";
import type {
    FeeSourceOrdersConditionCount} from "./fee-source-orders-conditions-count";
import {
    feeSourceOrdersConditionCountZodSchema,
} from "./fee-source-orders-conditions-count";

type FeeSourceOrdersCondition = FeeSourceOrdersConditionCount;
const feeSourceOrdersConditionZodSchema: z.ZodSchema<FeeSourceOrdersCondition> =
    feeSourceOrdersConditionCountZodSchema;

export type { FeeSourceOrdersCondition };
export { feeSourceOrdersConditionZodSchema };
